import {connect} from 'react-redux';
import ManageReviewers, {ManageReviewersProps} from './ManageReviewers';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import {ModalStates} from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: ManageReviewersContainerProps): ManageReviewersProps => {
   return {
      reviewerGroups: state.reviewerGroups,
      enableSaveGroup: ownProps.enableSaveGroup,
      prompt: ownProps.prompt,
      reviewers: ownProps.reviewers,
      showInput: ownProps.showInput,
      isOwner: ownProps.isOwner,
      modalState: state.modalState || ModalStates.closed,
      addReviewers: ownProps.addReviewers,
      cancelRemoveReviewer: ownProps.cancelRemoveReviewer,
      removeReviewer: ownProps.removeReviewer,
      themeName: state.themeName,
      errorText: ownProps.errorText,
      showRemoveReviewerText: ownProps.showRemoveReviewerText,
      notifyReviewer: ownProps.notifyReviewer
   };
};

export default connect(mapStateToProps, {})(ManageReviewers);

interface ManageReviewersContainerProps {
   prompt?: string;
   reviewers: SimpleReviewerModel[];
   isOwner: boolean;
   showInput?: boolean;
   enableSaveGroup?: boolean;
   errorText?: string;
   showRemoveReviewerText: boolean;
   addReviewers(reviewers: SimpleReviewerModel[]): void;
   cancelRemoveReviewer?(reviewer: SimpleReviewerModel): void;
   removeReviewer(reviewer: SimpleReviewerModel): void;
   notifyReviewer?(reviewer: SimpleReviewerModel, wantToNotify: boolean): void;
}
